'use es6';

import { Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import DocumentHead from 'ecosystem-marketplace-core/components/portals/DocumentHead';
import PrerenderReady from 'ecosystem-marketplace-core/components/prerender/PrerenderReady';
import { PublicOnly } from '../selectors/auth';
import { hasValidCategoryParam } from '../utils/params';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const withCategoryParamValidation = RouteComponent => props => {
  const {
    match: {
      params
    }
  } = props;
  const {
    category,
    superCategory
  } = params;
  if (category && !hasValidCategoryParam(params)) {
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(Redirect, {
        to: `/${superCategory}`
      }), /*#__PURE__*/_jsx(PublicOnly, {
        children: /*#__PURE__*/_jsx(DocumentHead, {
          children: /*#__PURE__*/_jsx(PrerenderReady, {
            statusCode: 404
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(RouteComponent, Object.assign({}, props));
};
export default withCategoryParamValidation;